import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';
import { ReactComponent as IMDbSVG } from 'assets/img/imdb.svg';

const StyledTitle = styled.div`
  width: ${scaleSize(1100)}px;
  color: ${({ theme }) => theme.detailsTitleTextColor};
  font-size: ${scaleSize(72)}px;
  line-height: ${scaleSize(88)}px;
  font-family: 'RobotoBold', sans-serif;
  position: absolute;
  z-index: 3;
  bottom: ${scaleSize(186)}px;
  left: ${scaleSize(220)}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledMetadata = styled.div`
  width: ${scaleSize(1100)}px;
  color: ${({ theme }) => theme.detailsMetadataTextColor};
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(48)}px;
  font-family: 'RobotoMedium', sans-serif;
  position: absolute;
  z-index: 3;
  bottom: ${scaleSize(60)}px;
  left: ${scaleSize(220)}px;

  & > div > span {
    padding-right: 30px;
  }
`;

export const IMDbIcon = styled(IMDbSVG)`
  width: ${scaleSize(56)}px;
  height: ${scaleSize(35)}px;
  padding-right: ${scaleSize(10)}px;
  padding-left: ${scaleSize(30)}px;
  vertical-align: text-bottom;
`;

export const Title = ({ children, className = '' }) => (
  <StyledTitle className={className}>{children}</StyledTitle>
);
export const Metadata = ({ children, className = '' }) => (
  <StyledMetadata className={className}>{children}</StyledMetadata>
);
